import { USER_MENU_APP_SESSION_KEY } from '@/config';

const _state = {
  menuItemId: null,
  companies: sessionStorage.getItem('user-companies')
    ? JSON.parse(sessionStorage.getItem('user-companies'))
    : null,
  permissions: sessionStorage.getItem('user-permissions')
    ? JSON.parse(sessionStorage.getItem('user-permissions'))
    : null,
  user: null,
  userMenu: sessionStorage.getItem(USER_MENU_APP_SESSION_KEY)
    ? JSON.parse(sessionStorage.getItem(USER_MENU_APP_SESSION_KEY))
    : null,
  userHasValidRole: sessionStorage.getItem('user-has-valid-role')
    ? JSON.parse(sessionStorage.getItem('user-has-valid-role'))
    : null,
  isLoggingOut: sessionStorage.getItem('user-is-Logging-out')
    ? JSON.parse(sessionStorage.getItem('user-is-Logging-out'))
    : null,
};

export const initialState = () => _state;

export const state = initialState();
